var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"internal-toolbar"},[_c('v-toolbar',{attrs:{"dense":"","elevation":0}},[_c('div',{staticClass:"d-flex flex-wrap"},[_vm._l((_vm.actions),function(action,index){return _c('EqsBtn',_vm._b({key:index,class:`internal-toolbar__btn`,attrs:{"input-value":(action.active && _vm.editor.isActive(...Object.values(action.active))) || false}},'EqsBtn',{
                    action: () => action.action(_vm.editor),
                    infoTxt: action.tooltip
                },false),[_c('v-icon',[_vm._v(" "+_vm._s(action.icon)+" ")])],1)}),_vm._t("actions")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }